import { gql } from "@apollo/client";

export const GET_CUSTOM_FIELD_SETTING = gql`
  query customFieldSetting($id: ID!) {
    customFieldSetting(id: $id) {
      id
      status
      parentTypes
      label
      type
      options
      allowMultipleEntries
      isRequired
      order
    }
  }
`;

export const GET_CUSTOM_FIELD_SETTINGS = gql`
  query customFieldSettings(
    $first: Int
    $after: String
    $status: [String]
    $parentType: ParentType
  ) {
    customFieldSettings(
      first: $first
      after: $after
      status: $status
      parentType: $parentType
    ) {
      edges {
        cursor
        node {
          id
          status
          parentTypes
          label
          type
          options
          allowMultipleEntries
          isRequired
          order
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const CREATE_CUSTOM_FIELD_SETTING = gql`
  mutation createCustomFieldSetting($input: CustomFieldSettingInput!) {
    createCustomFieldSetting(input: $input) {
      id
      status
      parentTypes
      label
      type
      options
      allowMultipleEntries
      isRequired
      order
    }
  }
`;

export const UPDATE_CUSTOM_FIELD_SETTING = gql`
  mutation updateCustomFieldSetting(
    $id: ID!
    $input: CustomFieldSettingInput!
  ) {
    updateCustomFieldSetting(id: $id, input: $input) {
      id
      status
      parentTypes
      label
      type
      options
      allowMultipleEntries
      isRequired
      order
    }
  }
`;

export const UPDATE_CUSTOM_FIELD_SETTING_STATUS = gql`
  mutation updateCustomFieldSettingStatus($id: ID!, $status: String!) {
    updateCustomFieldSettingStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
